const formatMember = (member) => {
  if (member === "Self") return "birthParent";
  else if (member === "Spouse") return "partner";
  else return member.toLowerCase().replace(" ", "_");
};

export const formatPBMs = (values) => {
  const { pharmacyManagersTable } = values;
  return pharmacyManagersTable.map((pbm) => {
    return {
      _id: pbm.id,
      name: pbm.name,
      tiers: Array.from({ length: pbm.numberOfTiers }, (_, i) => ({
        code: pbm.tierCodes[i],
        name: pbm.tierNames[i],
      })),
      pharmacyTypes: Array.from({ length: pbm.typesOfPharmacies }, (_, i) => ({
        type: pbm.pharmacyTypes[i],
        maxSupply: pbm.maxSupply[i],
      })),
    };
  });
};

export const formatPlans = (values, pbms) => {
  const { table, pharmacyManagersTable } = values;
  const adjustCoinsuranceRate = (coverage) => {
    return Object.fromEntries(
      Object.entries(coverage).map(([key, value]) => [
        key,
        {
          ...value,
          coinsuranceRate: {
            ...value.coinsuranceRate,
            value:
              value.drugsCoverageType === "coinsurance"
                ? value.coinsuranceRate.value > 50
                  ? (100 - value.coinsuranceRate.value) / 100
                  : value.coinsuranceRate.value / 100
                : 0,
          },
        },
      ]),
    );
  };

  return table.map((plan) => {
    const pbm = plan.pbmId
      ? pbms.find((pbm) => pbm._id === plan.pbmId)
      : pbms.find((pbm) => {
          const pbmFromForm = pharmacyManagersTable.find((formPBM) => formPBM.planList.includes(plan.label));
          return pbmFromForm.name === pbm.name;
        });
    const pbmId = pbm._id;

    const allowedPharmacyTypes = pbm.pharmacyTypes.map((pharmacyType) => pharmacyType.type);
    const allowedTiers = plan.tiers;
    const filterByAllowedTiers = (obj) =>
      Object.fromEntries(Object.entries(obj).filter(([key]) => allowedTiers.includes(key)));

    plan.retail = filterByAllowedTiers(plan.retail);
    plan.mailOrder = filterByAllowedTiers(plan.mailOrder);
    plan.preferredRetail = filterByAllowedTiers(plan.preferredRetail);
    plan.preferredMailOrder = filterByAllowedTiers(plan.preferredMailOrder);

    return {
      externalId: plan.id,
      pbmId,
      drugs: {
        individual: {
          deductible: plan.deductibleType === "separate" ? plan.individualDeductible : null,
          oopMax: plan.oopType === "separate" ? plan.individualOOPMax : null,
        },
        family: {
          deductible: plan.deductibleType === "separate" ? plan.familyDeductible : null,
          oopMax: plan.oopType === "separate" ? plan.familyOOPMax : null,
        },
        crossAccumulate: plan.deductibleType === "separate" ? plan.crossAccumulate : false,
        deductibleType: plan.deductibleType,
        oopType: plan.oopType,
        coverage: {
          retail:
            plan.retail && (allowedPharmacyTypes.includes("Retail") || allowedPharmacyTypes.includes("Standard Retail"))
              ? adjustCoinsuranceRate(plan.retail)
              : null,
          mailOrder:
            plan.mailOrder &&
            (allowedPharmacyTypes.includes("Mail Order") || allowedPharmacyTypes.includes("Standard Mail Order"))
              ? adjustCoinsuranceRate(plan.mailOrder)
              : null,
          preferredRetail:
            plan.preferredRetail && allowedPharmacyTypes.includes("Preferred Retail")
              ? adjustCoinsuranceRate(plan.preferredRetail)
              : null,
          preferredMailOrder:
            plan.preferredMailOrder && allowedPharmacyTypes.includes("Preferred Mail Order")
              ? adjustCoinsuranceRate(plan.preferredMailOrder)
              : null,
        },
        tiers: plan.tiers,
      },
    };
  });
};

export const formatDrugs = (values, pbms) => {
  const { drugsTable, pharmacyManagersTable } = values;

  return drugsTable.map((drug) => {
    const hasIdsFromDatabase = pharmacyManagersTable.every((pbm) => pbm.id);
    const ids = pharmacyManagersTable.map((pbm) => pbm.id);
    const tiers = Object.fromEntries(ids.map((id) => [id, drug[id] ? drug[id] : "unknown"]));
    const adjustedTiers = Object.fromEntries(
      pharmacyManagersTable
        .map((pbm) => ({ idx: pbm.idx, name: pbm.name }))
        .map((pbmFromTable) => [
          pbms.find((pbm) => pbm.name === pbmFromTable.name)._id,
          drug[pbmFromTable.idx] ? drug[pbmFromTable.idx] : "unknown",
        ]),
    );
    return {
      name: drug.name,
      cost: drug.cost,
      frequency: drug.frequency,
      for: formatMember(drug.for),
      tiers: hasIdsFromDatabase ? tiers : adjustedTiers,
    };
  });
};
